__turbopack_context__.v({
  "add-between": "FormView-module__xv9WGG__add-between",
  "add-inline": "FormView-module__xv9WGG__add-inline",
  "add-inline-btn": "FormView-module__xv9WGG__add-inline-btn",
  "between-hover": "FormView-module__xv9WGG__between-hover",
  "form-view": "FormView-module__xv9WGG__form-view",
  "node-header": "FormView-module__xv9WGG__node-header",
  "on-hover": "FormView-module__xv9WGG__on-hover",
  "row-wrapper": "FormView-module__xv9WGG__row-wrapper",
  "tree-row": "FormView-module__xv9WGG__tree-row",
});
